// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Remittance'"></sub-header>

  <div class="tab-menu">
    <ul class="nav-tabs">
      <li class="active">
        <a data-target="#tab-upload" data-toggle="tab">
          Upload
        </a>
      </li>
      <li>
        <a data-target="#tab-history" data-toggle="tab">
          History
        </a>
      </li>
    </ul>
  </div>

  <div class="tab-content no-print">
    <div ng-if="\$ctrl.authentication.permissions['BATCH_REMITTANCE_UPLOAD_VIEW']" class="tab-pane active" id="tab-upload">
      <batch-remittance-upload></batch-remittance-upload>
    </div>

    <div ng-if="\$ctrl.authentication.permissions['BATCH_REMITTANCE_HISTORY_VIEW']" class="tab-pane" id="tab-history">
      <batch-remittance-history></batch-remittance-history>
    </div>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/remittance/batch-remittance.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;